export default __webpack_public_path__ + "static/media/step-4.a6e121fe.png";